"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uniqueId = uniqueId;
exports.contains = contains;
var i = 0;
function uniqueId() {
    return (i++).toString();
}

function contains(array, element) {
    return array.indexOf(element) !== -1;
}


//////////////////
// WEBPACK FOOTER
// ./~/ddp.js/lib/utils.js
// module id = 1253
// module chunks = 1